<h2 mat-dialog-title> Create New City </h2>
<mat-dialog-content class="dialog">
  <form [formGroup]="cityForm">

    <mat-form-field class="form-element">
      <mat-label> City Name </mat-label>
      <input matInput placeholder="City Name" formControlName="name">
    </mat-form-field>

    <mat-form-field class="form-element">
      <mat-label> Select Country </mat-label>
      <mat-select type="text" placeholder="Select Country" [formControl]="countryControl">
        @for (country of filteredCountries$ | async; track country) {
          <mat-option [value]="country">
            {{ country.name }}
          </mat-option>
        }
      </mat-select>
      @if (coordinatesLoading) {
        <div class="form-wrapper__table-loading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </mat-form-field>

    <mat-form-field class="form-element">
      <mat-label> Latitude - Longitude must already exist in the system</mat-label>

      <mat-select type="text" placeholder="Latitude and Longitude must already exist in the system" [formControl]="latLonControl">
        @for (coordinateItem of filteredCoordinates$ | async; track coordinateItem) {
          <mat-option [value]="coordinateItem" >
            {{ coordinateItem.lat }}, {{ coordinateItem.lon }}
          </mat-option>
        }
      </mat-select>
      @if (coordinatesLoading) {
        <div class="form-wrapper__table-loading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }

    </mat-form-field>

    @if (isCityDuplicate) {
      <div class="errorMsg"><button mat-icon-button>
        <mat-icon>priority_high</mat-icon>
      </button>
      <p>The city already exists, please check the name and coordinates. </p>
    </div>
  }
</form>
</mat-dialog-content>
@if (tableLoading) {
  <div class="form-wrapper__table-loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-actions>
  <button class="greyBtn" mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" type="submit" data-testid="submit" [disabled]="!cityForm.valid"
  (click)="onSubmit(cityForm.value)"> Create </button>
</mat-dialog-actions>
